module.exports = __webpack_public_path__ + "img/szhxNo3_3.7ec20906.png";